(function() {
  
  angular.module('GoProfileProvider', [])
  
  .factory('GoProfileModel',
  ['$http', '$q', 'PrinterModel', 
  function($http, $q, PrinterModel) {
    return function(data) {
      var GoProfileModel = {
        name: data.name,
        info: data,
        links: data._links,
        id: extractId(data._links.self.href),
        encodedLink: encodePrintQueueLink(data)
      };

      function extractId (selfLink) {
        var id = selfLink.split('/');
        id = id[id.length -1];
        return id;
      }

      function encodePrintQueueLink (goProfile) {
        return encodeURIComponent(encodeURIComponent(goProfile._links.self.href));
      }

      GoProfileModel.getPrinters = function (pageParams, embedPrinterStatus) {
        var deferred = $q.defer();
        var params = '&' + pageParams.getPagedUrlParameters();
        var url = GoProfileModel.info._links['px:printers'].href + params;

        if (embedPrinterStatus) {
          url = url + '&embed=status';
        }

        $http.get(url).then(function(response) {
          var pageObject = {
            page: response.data.page,
            list: []
          }
          if (response.data._embedded) {
            pageObject.list = response.data._embedded['px:printerResources'];
            for (var i = 0; i < pageObject.list.length; i++) {
              pageObject.list[i] = new PrinterModel(pageObject.list[i]);
            }
          }
          deferred.resolve(pageObject);
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      }

      GoProfileModel.testPrinters = function () {
        var deferred = $q.defer()
        var url = GoProfileModel.links['px:testAllPrinterCredential'].href;
        $http.post(url).then(function(response) {
          deferred.resolve(response);
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      }

      GoProfileModel.testPrinter = function (printer) {
        var deferred = $q.defer();
        var printerId = printer.info._links.self.href.split('/')
        printerId = printerId[printerId.length - 1];

        var url = GoProfileModel.links['px:testPrinterCredential'].href + '?printerIds=' + printerId;
        $http.post(url).then(function(response) {
          deferred.resolve(response);
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      }

      return GoProfileModel;
    }
  }])

  .factory('GoProfilePaging',
  ['DEFAULT_ITEMS_PER_PAGE', 
  function(DEFAULT_ITEMS_PER_PAGE) {
    return function () {
      var GoProfilePaging = {};

      GoProfilePaging.pagingCriteria = {
        page: 0,
        pageSize: DEFAULT_ITEMS_PER_PAGE,
        direction: "ASC",
        sort: 'NAME',
        match: null,
      }

      GoProfilePaging.getPagedUrlParameters = function() {
        var urlParameters =
          '?page=' + GoProfilePaging.pagingCriteria.page +
          "&pageSize=" + GoProfilePaging.pagingCriteria.pageSize +
          "&direction=" + GoProfilePaging.pagingCriteria.direction +
          "&sort=" + GoProfilePaging.pagingCriteria.sort;
        
        if (GoProfilePaging.pagingCriteria.match) {
          urlParameters += "&match=" + GoProfilePaging.pagingCriteria.match;
        }

        return urlParameters;
      }
      return GoProfilePaging;
    }
  }])
  

  .service('GoProfileService', 
    ['$http', '$q', 'TenantListService', 'GoProfileModel',
    function($http, $q, TenantListService, GoProfileModel) {

      this.getGoProfilePaged = function (printerSignInProfilePaging) {
        var deferred = $q.defer();
        var url = TenantListService.currentTenant.info._links["px:printerCredentials"].href;
        $http.get(url + printerSignInProfilePaging.getPagedUrlParameters()).then(function(response) {
          var listObject = {
            page: response.data.page,
            _links: response.data._links,
            list: []};

          if (response.data._embedded) {
            angular.forEach(response.data._embedded["px:printerCredentialResources"], function(printerSignInProfile) {
              listObject.list.add(new GoProfileModel(printerSignInProfile));
            });
          }

          deferred.resolve(listObject);
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      }

    }
  ])  

})();